"use strict";

var mapL = require("./mapL.js");

var tap = require("../Strict/tap.js");

var curry = require("../Strict/curry.js");

const eachL = curry((f, iter) => mapL(tap(f), iter));
module.exports = eachL;